import {NgModule} from '@angular/core';
import {SplitPipe} from './pipe/split-pipe';
import {AutoFocusDirective} from './directive/auto-focus.directive';
import {ConnectFormDirective} from './directive/connect-form.directive';

@NgModule({
  declarations: [SplitPipe, AutoFocusDirective, ConnectFormDirective],
  imports: [],
  exports: [SplitPipe, AutoFocusDirective, ConnectFormDirective]
})
export class NcUtilsModule {
}
